import { addItemToCollection } from "directus/src/operations";

export async function createTechStack({ item }) {
  try {
    const data = await addItemToCollection("tech_stack", item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
